/**
 * ProductImages Component
 */

//jshint ignore:start
(function () {

    'use strict';

    /**
     * Product Images components viewer
     * @name productImagesCtrl
     * @type ItxProductImagesCmpCtrl
     */
    var ItxProductImagesCmp = {
        bindings: {
            product: '<',
            isBundleBean: '<',
            color: '<',
            hasRelated: '<',
            onSlide: '&',
            onLastSlide: '&',
            hasDialog: '<',
            bulletPercentage: '<'
        },
        controller: ItxProductImagesCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'product-images.component.html'
    };

    angular.module('itxApp.catalog')
        .component('itxProductImages', ItxProductImagesCmp);

    ItxProductImagesCmpCtrl.$inject = [
        '$rootScope',
        '$scope',
        '$timeout',
        '$element',
        'ItxConstants',
        'ItxScreenSizeSvc',
        'ItxUtilsFct',
        'imProductService',
        'itxAkamaiSvc'
    ];

    function ItxProductImagesCmpCtrl( 
        $rootScope, 
        $scope, 
        $timeout, 
        $element, 
        ItxConstants, 
        ItxScreenSizeSvc, 
        ItxUtilsFct, 
        imProductService,
        itxAkamaiSvc
    ) {

        var _this = this;
        _this.ItxScreenSizeSvc = ItxScreenSizeSvc;
        _this.isChina = (inditex.iCountryCode == 'CN');
        
        _this.$onChanges =function(){
            _this.init();
        }

        _this.$onInit = function () {}

        _this.init = function () {
            _this.uniqueImage = false;
            _this.hasSlideImages = false;
            
            //force refreshing img src
            if( _this.arrayImages){
                for(var i = 0; i < _this.arrayImages.length; ++i){
                    _this.arrayImages[i] = "";
                }
            }
            
            if(!_this.product){
                return;
            }
            
            _this.product.setLayoutProduct('#product-images-grid');
            
            if( _this.hasDialog || ItxScreenSizeSvc.is('xs') ){
                _this.hasSlideImages = true;
            }

            if(!_this.hasDialog){
                ItxScreenSizeSvc.when('xs', function(){
                    _this.hasSlideImages = true;
                })
                ItxScreenSizeSvc.when('sm,md,lg', function(){
                    _this.hasSlideImages = false;
                })  
            }

            _this.setMinHeight();
        };

        _this.setMinHeight = function (params) {
            if(ItxScreenSizeSvc.is('sm')){
                $timeout(function() {
                    var minHeight = $('.ma-product-bundle-container').height();
                    $('.ma-product-slider-wrap').css('min-height', minHeight+'px');
                },100);
            }
        };

        _this.showVideo = function(image){
            image.showVideo = true;
        }

        _this.zoom = function ($index, $event) {

            var images = [];

            if (_this.color) {
                images = ItxUtilsFct.getImageProductUrls(_this.product.activeDetail, _this.color.id, 'productPage', 'main', 'zoom');
               
                if (!ItxUtilsFct.isXmediaEnabled(_this.product.activeDetail)) {
                    var alternativeImages = ItxUtilsFct.getImageProductUrls(_this.product.activeDetail, _this.color.id, null, 'alternative', 'zoom');

                    if (alternativeImages && alternativeImages.length === 0) {
                        _this.uniqueImage = true;
                        images =  ItxUtilsFct.getImageProductUrls(_this.product.activeDetail, _this.color.id, null, 'productUnique', 'zoom');
                    }
                    images = images.concat(alternativeImages);
                }

                $rootScope.$broadcast('itx-product-zoom:initialize', {
                    images: images,
                    index: $index,
                    event: $event,
                    productId: _this.product.id
                });
            }

            /*
             * IMAnalytics: ver_zoom en ficha de producto
             */
            imProductService.eventZoom($index);
        };


        /*
        $scope.$watch('color', function(newVal, oldVal) {
            if (ItxScreenSizeSvc.is('md,lg')) {
                $timeout(function() {
                    $element.find('img').each(function(index, image) {
                        var $this = $(this);
                        var width = $this.parent().width();
                        var height = width * ItxConstants.imageAspectRatio;
                        $this.css('min-height', height+'px');
                    });
                });
            }

            $(window).off('resize.p-images').on('resize.p-images', function() {
                $('itx-product-images img').each(function(index, image) {
                    var $this = $(this);
                    var width = $this.parent().width();
                    var height = width * ItxConstants.imageAspectRatio;
                    $this.css('min-height', '');
                });
            });
        });
        */
    }

})();
